<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4 class="mb-4">Citas Médicas por Fecha</h4>
    <hr>

    <!--  Botones de rango rápido  -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-outline-primary"   @click="setDateRange(getToday)">Hoy</button>
      <button class="btn btn-outline-danger"    @click="setDateRange(getThisWeek)">Semana Actual</button>
      <button class="btn btn-outline-secondary" @click="setDateRange(getThisMonth)">Mes Actual</button>
      <button class="btn btn-outline-success"   @click="setDateRange(getThisQuarter)">Trimestre Actual</button>
      <button class="btn btn-outline-info"      @click="setDateRange(getThisSemester)">Semestre Actual</button>
      <button class="btn btn-outline-warning"   @click="setDateRange(getThisYear)">Año Actual</button>
    </div>

<!--  Selector de fechas  -->
<div class="fecha-bar mb-3">
  <div class="fecha-campo">
    <label class="form-label">Desde</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaDesde">
  </div>
  <div class="fecha-campo">
    <label class="form-label">Hasta</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaHasta">
  </div>
  <button class="btn btn-dark btn-icono" @click="fetchCitas()">
    <span class="material-symbols-outlined">search</span>
    Consultar
  </button>
</div>

    <!--  DataTable  -->
    <DataTable
      :data="citas"
      :columns="columnas"
      idField="idCita"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay citas para el rango de fechas seleccionado."
      @refresh="fetchCitas()"
    >
      <!-- Celda: Fecha formateada -->
      <template #cell-fechaCita="{ row }">
        {{ getFormattedDate(row.fechaCita) }}
      </template>

      <!-- Celda: Estado con color -->
      <template #cell-estadoCita="{ row }">
        <span class="badge-estado" :class="getClassForCitaEstado(row.estadoCita)">
          {{ row.estadoCita }}
        </span>
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import Swal       from 'sweetalert2'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

export default {
  name: 'CitasPorFecha',
  components: { Layout, Footer, DataTable },

  data() {
    return {
      fechaDesde: '',
      fechaHasta: '',
      citas:      [],

      // Exponer helpers al template
      getToday, getThisWeek, getThisMonth,
      getThisQuarter, getThisSemester, getThisYear,

      columnas: [
        { field: 'numero',             label: 'Núm.' },
        { field: 'fechaCita',          label: 'Fecha Cita' },
        { field: 'horaDesde',          label: 'Hora Desde' },
        { field: 'horaHasta',          label: 'Hora Hasta' },
        { field: 'nombrePaciente',     label: 'Nombre Paciente' },
        { field: 'nombreMedico',       label: 'Nombre Médico' },
        { field: 'nombreEspecialidad', label: 'Especialidad' },
        { field: 'estadoCita',         label: 'Estado Cita' },
      ],
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    setDateRange(getRangeFunction) {
      const { fechaDesde, fechaHasta } = getRangeFunction()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.fetchCitas()
    },

    validarFechas() {
      if (!this.fechaDesde || !this.fechaHasta) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos requeridos',
          text: 'Debe seleccionar las fechas desde y hasta.',
          confirmButtonText: 'Aceptar',
        })
        return false
      }
      return true
    },

    fetchCitas() {
      if (!this.validarFechas()) return
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get('/vwcitas/por-fecha', {
        params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
      })
      .then(response => { this.citas = response.data })
      .catch(error   => console.error('Error fetching citas:', error))
    },

    getClassForCitaEstado(estado) {
      return {
        'PROGRAMADA':   'programada',
        'REPROGRAMADA': 'reprogramada',
        'CONFIRMADA':   'confirmada',
        'EN PROCESO':   'en-proceso',
        'CANCELADA':    'cancelada',
        'AUSENCIA':     'ausencia',
      }[estado] || ''
    },
  },
}
</script>

<style src="@/assets/css/fechaBar.css" scoped></style>
<style scoped>
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}
.programada   { background-color: #a2cf6e; }
.reprogramada { background-color: #f7d08a; }
.confirmada   { background-color: #68b3c8; }
.en-proceso   { background-color: #6eaff2; }
.cancelada    { background-color: #f76c6c; }
.ausencia     { background-color: #e2e2e2; }

/* Botones de rango — ya tienen flex-wrap, solo ajustar tamaño en móvil */
@media (max-width: 576px) {
  .d-flex.flex-wrap .btn { flex: 1 1 calc(50% - 8px); font-size: 13px; }
}
</style>